import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

export const ADD_TOUCHPOINTS_TO_BATCH_VALIDATION_SCHEMA = zodResolver(
  z.object({
    chosenCampaign: z.object({
      label: z.string(),
      value: z.string(),
    }),
    chosenTouchpoints: z.array(z.any()).min(1, "At least one creative is required"),
  }),
);
